import { api as weblinksApi } from './auto-generated/weblinks'

interface WebLink {
  id: number
  title: string | null
  link: string | null
  tags: string[] | null
  shared_with: number[]
  is_public?: boolean | null
}

weblinksApi.enhanceEndpoints({
  endpoints: {
    weblinksCreateWeblink: {
      async onQueryStarted(args, { dispatch, queryFulfilled }) {
        try {
          const response = await queryFulfilled
          dispatch(
            weblinksApi.util.updateQueryData(
              'weblinksGetWeblinks',
              { query: '' },
              (draftWeblinks: WebLink[]) => {
                draftWeblinks.push(response.data)
              },
            ),
          )
        } catch {
          console.error('Error creating weblink')
        }
      },
    },
    weblinksDeleteWeblink: {
      async onQueryStarted(args, { dispatch, queryFulfilled }) {
        const patchResult = dispatch(
          weblinksApi.util.updateQueryData(
            'weblinksGetWeblinks',
            { query: '' },
            (draftWeblinks: WebLink[]) => {
              return draftWeblinks.filter((e: WebLink) => e.id !== args.weblinkId)
            },
          ),
        )
        try {
          await queryFulfilled
        } catch {
          patchResult.undo()
        }
      },
    },
    weblinksUpdateWeblinks: {
      async onQueryStarted(args, { dispatch, queryFulfilled }) {
        const patchResult = dispatch(
          weblinksApi.util.updateQueryData(
            'weblinksGetWeblinks',
            { query: '' },
            (draftWeblinks: WebLink[]) => {
              draftWeblinks.map((e: WebLink) => {
                if (e.id === args.weblinkId) {
                  e.title = args.updateWeblinkRequest.title ?? null
                  e.link = args.updateWeblinkRequest.link ?? null
                  e.tags = args.updateWeblinkRequest.tags ?? null
                  e.is_public = args.updateWeblinkRequest.is_public ?? null
                  e.shared_with = args.updateWeblinkRequest.shared_with ?? []
                }
              })
            },
          ),
        )
        try {
          await queryFulfilled
        } catch {
          patchResult.undo()
        }
      },
    },
  },
})

export { weblinksApi }
